var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "logobar" }, [
    _c(
      "div",
      { staticClass: "container" },
      [
        _c(
          "router-link",
          { staticClass: "logo", attrs: { to: _vm.logoTo } },
          [
            _vm.currentCategoryImage
              ? [
                  _c("img", {
                    staticClass: "logo-category-img",
                    attrs: {
                      src: _vm.currentCategoryImage,
                      alt: _vm.currentCategoryName,
                    },
                  }),
                ]
              : _vm.shopLogo
              ? [_c("img", { attrs: { src: _vm.shopLogo, alt: _vm.appName } })]
              : [
                  _c("img", {
                    attrs: {
                      src: "/assets/img/header/header-bi.svg",
                      alt: _vm.appName,
                    },
                  }),
                  _vm._v(" "),
                  _c("img", {
                    attrs: {
                      src: "/assets/img/header/header-logo.svg",
                      alt: _vm.appName,
                    },
                  }),
                ],
          ],
          2
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }